import * as IncludedOptions from './components/IncludedOptions.css';

export default {
	IncludedOptions
};
